<script setup lang="ts">
import { IEvent } from "~/types/sports/event";
import { IPrice } from "~/types/sports/price";
import { IOutcome } from "~/types/sports/outcome";
import Outcome from "./Outcome.vue";
import { IResult } from "~/types/racing/race-results";
import { IJackpotBet } from "~/types/racing/jackpot-bets";

export interface IOutcomeWithPrice extends IOutcome {
	price: IPrice;
	raceResult?: IResult;
}

interface Props {
	event?: IEvent;
	outcomes: IOutcome[];
	prices: IPrice[];
	raceResults?: IResult[] | undefined;
	selectedLines?: IOutcome[] | [];
	jackpotBets?: IJackpotBet[] | [];
}
const emit = defineEmits(["outcome-selected"]);
const props = defineProps<Props>();

const outcomes = computed(
	() =>
		props.outcomes.map((outcome) => ({
			...outcome,
			raceResult: props.raceResults?.find((r) => r.horseName === outcome.displayName) || undefined,
		})) as IOutcomeWithPrice[]
);

const sortedOutcomes = computed(() =>
	outcomes.value.sort((a, b) => {
		if (!a.raceResult) return 1;
		if (!b.raceResult) return -1;
		const aResult = a.raceResult?.position ?? 0;
		const bResult = b.raceResult?.position ?? 0;
		return aResult - bResult;
	})
);
</script>

<template>
	<div
		v-for="outcome in sortedOutcomes"
		:key="outcome.outcomeId"
		class="m-2 rounded-md border border-light-500 dark:dark:border-dark-400 overflow-hidden"
	>
		<Outcome
			@outcome-selected="emit('outcome-selected', $event)"
			:outcome="outcome"
			:is-selected="
				(selectedLines && selectedLines.some((bet) => bet.displayName === outcome.displayName)) ||
				jackpotBets?.some((s) => s.outcome === outcome.displayName)
			"
			:is-place-market-selected="jackpotBets?.some((s) => s.market.toLowerCase().includes('top') && outcome.displayName === s.outcome)"
			:isEventActive="event?.isActive"
		/>
	</div>
</template>
